// libs
import styled from "@emotion/styled";

// components
import LinkButton from "shared/components/AuthModal/components/LinkButton";

export const Container = styled.div`
    position: relative;

    .input {
        padding-right: 52px;
    }
`;

export const Button = styled(LinkButton)`
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    text-transform: uppercase;
    font-size: 0.85rem;
    border-bottom: 0;
`;
